import * as yup from 'yup';
import {
  validateCity,
  validateCompanyName,
  validateSwedishPostalCode,
} from '../../../../utils/validation';

export const companyDetailsValidationSchema = yup.object().shape({
  desiredCompanyName: validateCompanyName.required('Önskat företagsnamn krävs'),

  firstAlternativeCompanyName: validateCompanyName.required(
    'Alternativt företagsnamn krävs',
  ),

  secondAlternativeCompanyName: validateCompanyName.required(
    'Andra alternativa företagsnamn krävs',
  ),

  nameReview: yup.boolean(),

  address: yup.string().trim().required('Adress krävs'),

  postalCode: validateSwedishPostalCode(true),

  city: validateCity,

  municipality: yup.object().nullable().required('Du måste välja en kommun'),

  businessDescription: yup
    .string()
    .trim()
    .nullable()
    .required('Företagsbeskrivning krävs'),

  taxHelp: yup.boolean(),
});

export const businessTemplatesDefault = 'Välj om du vill utgå från exempel...';

export const businessTemplates = {
  [businessTemplatesDefault]:
    'Bolaget ska bedriva ... samt därmed förenlig verksamhet.',
  Fastighetsbolag:
    'Bolaget ska äga och förvalta fast egendom samt bedriva därmed förenlig verksamhet.',
  Holdingbolag:
    'Bolaget ska äga och förvalta aktier och andelar i dotter- och intressebolag samt bedriva därmed förenlig verksamhet.',
  Byggverksamhet:
    'Bolaget ska bedriva byggverksamhet samt därmed förenlig verksamhet.',
  Anläggning:
    'Bolaget ska bedriva entreprenadverksamhet inom mark och anläggning samt därmed förenlig verksamhet.',
  'Åkeri/Transport':
    'Bolaget ska bedriva åkerirörelse och transportverksamhet, uthyrning av transportredskap samt därmed förenlig verksamhet.',
  'Frisör-/Skönhetssalong':
    'Bolaget ska bedriva hårvård och skönhetsvård, försäljning av skönhetsrelaterade produkter samt därmed förenlig verksamhet.',
  Advokat:
    'Bolaget ska bedriva advokatverksamhet samt därmed förenlig verksamhet.',
  Läkare:
    'Bolaget ska bedriva sjukvårds- och läkartjänster samt därmed förenlig verksamhet.',
  'Städ-/Hemtjänster':
    'Bolaget ska bedriva städtjänster och hemservice samt därmed förenlig verksamhet.',
  'Musik/Litteratur':
    // eslint-disable-next-line max-len
    'Bolaget ska bedriva litterärt och konstnärligt skapande, bedriva management, förlagsverksamhet, produktion, liveframträdanden och inspelningsverksamhet samt därmed förenlig verksamhet.',
  Gym: 'Bolaget ska bedriva drift av gymanläggningar samt därmed förenlig verksamhet.',
  Konsult:
    'Bolaget ska bedriva konsultverksamhet inom ... (OBS! MÅSTE PRECISERAS) samt därmed förenlig verksamhet.',
  'Tillfälligt boende':
    'Bolaget ska bedriva tillfälligt boende för asylsökande samt därmed förenlig verksamhet.',
  'Annat...': 'Bolaget ska bedriva ... samt därmed förenlig verksamhet.',
} as const;
